import {
  useGetService,
  type UseGetServiceOptions,
} from "@libs/service-providers/api-service-provider";

import { ALERTS_URL } from "./apiEndpoints";
import type { AlertItem } from "./types";

type Params = {
  severity?: string;
  status?: string;
};

type Options = Omit<UseGetServiceOptions<AlertItem[]>, "route" | "queryKey"> & {
  params?: Params;
};

export const useGetAlerts = (options?: Options) =>
  useGetService<AlertItem[]>({
    route: ALERTS_URL,
    queryKey: ["dq-dashboard", "alerts", options?.params],
    config: { ...options?.config, params: options?.params },
    retry: false,
    ...(options ?? {}),
  });
